import {
  InfoIcon,
  WarningCircleIcon,
} from '@phosphor-icons/react'
import { Banner } from '@cloudflare/kumo/components/banner'

const variants = {
  error: {
    icon: <WarningCircleIcon size={20} weight="fill" />,
    title: 'Terjadi kesalahan',
  },
  alert: {
    icon: <WarningCircleIcon size={20} weight="fill" />,
    title: 'Perlu diperhatikan',
  },
  default: {
    icon: <InfoIcon size={20} weight="fill" />,
    title: 'Informasi',
  },
  secondary: {
    icon: <InfoIcon size={20} weight="fill" />,
    title: 'Informasi',
  },
}

export default function AppAlert({
  variant = 'default',
  title,
  description,
  className = '',
}) {
  const presentation = variants[variant] || variants.default

  return (
    <Banner
      role={variant === 'error' || variant === 'alert' ? 'alert' : 'status'}
      variant={variant}
      icon={presentation.icon}
      title={title || presentation.title}
      description={description}
      className={className}
    />
  )
}
